import { useMemo } from 'react';
import { TField } from '../basis/types/tfield';

export const useMeetingType = (meetingType?: TField.MeetingType) => {
  const isMeetingLive = useMemo(() => meetingType === TField.MEETING_TYPE_LIVE, [meetingType]);

  return { isMeetingLive };
};
